const RUPTURE_MS_DEFAUT = 2 * 60 * 60 * 1000;

const METRIQUES_SUPPORTEES = ['batteryPercent', 'freeMb', 'memoryAvailMb'];

const NOMS_METRIQUES = {
  batteryPercent: 'Batterie (%)',
  freeMb: 'Stockage libre (MB)',
  memoryAvailMb: 'RAM disponible (MB)',
};

function estValeurNumerique(valeur) {
  return typeof valeur === 'number' && Number.isFinite(valeur);
}

function toMs(ts) {
  if (typeof ts === 'number') return Number.isFinite(ts) ? ts : null;
  const parsed = Date.parse(ts);
  return Number.isNaN(parsed) ? null : parsed;
}

function metriquesDisponiblesDepuis(points) {
  return METRIQUES_SUPPORTEES.filter((metrique) => (
    points.some((point) => point && estValeurNumerique(point[metrique]))
  ));
}

function statsVides() {
  return { debut: null, fin: null, min: null, max: null, moyenne: null, pasAssezDeDonnees: true };
}

function calculerStats(pointsValides) {
  if (pointsValides.length === 0) return statsVides();

  const tries = [...pointsValides].sort((a, b) => a.x - b.x);
  const valeurs = tries.map((point) => point.y);
  const somme = valeurs.reduce((total, valeur) => total + valeur, 0);

  return {
    debut: tries[0].x,
    fin: tries[tries.length - 1].x,
    min: Math.min(...valeurs),
    max: Math.max(...valeurs),
    moyenne: somme / valeurs.length,
    pasAssezDeDonnees: pointsValides.length < 3,
  };
}

function projeterMetriquesAppareils(points, options = {}) {
  const tousPoints = Array.isArray(points) ? points.filter(Boolean) : [];
  const ruptureMs = Number.isFinite(options.ruptureMs) ? options.ruptureMs : RUPTURE_MS_DEFAUT;
  const metriquesDisponibles = metriquesDisponiblesDepuis(tousPoints);
  const metriqueSelectionnee = metriquesDisponibles.includes(options.metrique)
    ? options.metrique
    : (metriquesDisponibles[0] || null);

  if (!metriqueSelectionnee) {
    return {
      metriquesDisponibles,
      metriqueSelectionnee: null,
      series: [],
      stats: statsVides(),
    };
  }

  const groupesParCamera = new Map();
  tousPoints.forEach((point) => {
    const valeur = point[metriqueSelectionnee];
    if (!estValeurNumerique(valeur)) return;
    const ms = toMs(point.ts);
    if (ms === null) return;
    const cameraId = point.cameraId || 'inconnue';
    if (!groupesParCamera.has(cameraId)) groupesParCamera.set(cameraId, []);
    groupesParCamera.get(cameraId).push({ x: ms, y: valeur });
  });

  const tousPointsValides = [];
  const series = Array.from(groupesParCamera.entries())
    .map(([cameraId, pointsCamera]) => {
      const tries = [...pointsCamera].sort((a, b) => a.x - b.x);
      const pointsAvecRuptures = [];
      tries.forEach((point, index) => {
        if (index > 0 && point.x - tries[index - 1].x > ruptureMs) {
          pointsAvecRuptures.push({ x: null, y: null });
        }
        pointsAvecRuptures.push(point);
        tousPointsValides.push(point);
      });
      return { id: cameraId, nom: `Caméra ${cameraId}`, points: pointsAvecRuptures };
    })
    .sort((a, b) => String(a.id).localeCompare(String(b.id)));

  return {
    metriquesDisponibles,
    metriqueSelectionnee,
    series,
    stats: calculerStats(tousPointsValides),
  };
}

module.exports = {
  projeterMetriquesAppareils,
  METRIQUES_SUPPORTEES,
  NOMS_METRIQUES,
};



// WEBPACK FOOTER //
// src/components/cockpit/metriquesAppareilsProjection.js